<template>
  <div>
      <topTab :changeTabIndex='3'></topTab>
      <blendpage></blendpage>    
      <bottomMsg></bottomMsg>
  </div>
</template>

<script>
// @ is an alias to /src
import blendpage from "@/components/blend/blend.vue"
import bottomMsg from "@/components/bottomMsg/bottomMsg.vue"
import topTab from "@/components/topTab/topTab.vue"
export default {
  name: 'home',
  components: {
    blendpage,
    bottomMsg,
    topTab
  }
}
</script>
